import { render, staticRenderFns } from "./ImportGuidePage.vue?vue&type=template&id=a06f1796&"
import script from "./ImportGuidePage.vue?vue&type=script&lang=js&"
export * from "./ImportGuidePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports